export type WeeklyRotationPreview = {
  weekStart: string;
  room: { id: number; label: string };
  member: { id: number; name: string | null } | null;
  uncovered: boolean;
  lockedAssignment: {
    id: number;
    status: "notified" | "submitted" | "completed";
    room: { id: number; label: string } | null;
    member: { id: number; name: string | null } | null;
  } | null;
  differsFromRotation: boolean;
};

export function getWeeklyRotationDisplay(item: WeeklyRotationPreview) {
  const locked = item.lockedAssignment;
  return {
    room: locked?.room ?? item.room,
    member: locked?.member ?? item.member,
    uncovered: locked ? !locked.member : item.uncovered,
  };
}